"use client";

import Link from "next/link";
import PropertyListingCard from "@/components/bnp-ui/listing-card/PropertyListingCard";
import { buildPropertyDetailsUrl } from "@/utils/propertyReferrer";
import type { Property } from "@/types/property";

interface Props {
  property: Property;
}

export default function StatePropertyCard({ property }: Props) {
  const href = buildPropertyDetailsUrl(
    property.id,
    undefined,
    property.realtor?.slug || property.realtor?.id,
  );
  return (
    <Link href={href} className="block h-full">
      <PropertyListingCard property={property} />
    </Link>
  );
}
